import React from "react";
import { Modal, Button } from "react-bootstrap";

import "../styles/ForgotPasswordModal.css";

const ForgotPasswordModal = ({ show, handleClose, onClose }) => {
  const handleModalClose = () => {
    if (onClose) {
      onClose(); // Perform action on modal close
    }
    handleClose(); // Close the modal
  };

  return (
    <Modal show={show} onHide={handleModalClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Forgot Your Password?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center mb-4">
          If you need assistance with your password, please contact our MSIL team at 
          <strong><a href="mailto:test@test.com"> dmssupport@dxc.com</a></strong>.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleModalClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ForgotPasswordModal;
